import { useState } from 'react';

import { ExecutiveSnapshotDocument, useUpdateExecutiveSnapshotMutation } from '../types/api.graphql';
import { handlePdfDownload } from '../utils/pdfUtils';

interface ReviewTarget {
  id: string;
  pdfUrl: string;
  title: string;
  alreadyReviewed: boolean;
  outdated?: boolean;
}

export const useReviewBeforeDownload = () => {
  const [target, setTarget] = useState<ReviewTarget | null>(null);
  const [busy, setBusy] = useState(false);
  const [updateExecutiveSnapshot] = useUpdateExecutiveSnapshotMutation();

  const openReviewDownload = (next: ReviewTarget) => {
    if (next.alreadyReviewed || next.outdated) {
      void handlePdfDownload(next.pdfUrl, next.title);
    } else {
      setTarget(next);
    }
  };
  const close = () => setTarget(null);

  const markReviewedAndDownload = async () => {
    if (target) {
      setBusy(true);

      try {
        await updateExecutiveSnapshot({
          variables: { id: target.id, params: { reviewedAt: new Date().toISOString() } },
          refetchQueries: [ExecutiveSnapshotDocument],
        });
        await handlePdfDownload(target.pdfUrl, target.title);
      } finally {
        setBusy(false);
        close();
      }
    }
  };

  const downloadOnly = async () => {
    if (target) {
      setBusy(true);

      try {
        await handlePdfDownload(target.pdfUrl, target.title);
      } finally {
        setBusy(false);
        close();
      }
    }
  };

  return {
    isOpen: !!target,
    busy,
    openReviewDownload,
    close,
    markReviewedAndDownload,
    downloadOnly,
  };
};
